import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import * as PIXI from 'pixi.js';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CreatePageConstants from '../../../../CreatePageConstants';
import LyricsGlowBlurListItem from './LyricsGlowBlurListItem';
import LyricsGlowScaleListItem from './LyricsGlowScaleListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';

const LyricsGlowListItem = (props) => {
    const { glowSettingsEnabled, updateLyricsStyle } = props;

    const onGlowEnabledChange = (value) => updateLyricsStyle({ 
        glowSettings: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={glowSettingsEnabled}
            text='Glow'
            onChange={onGlowEnabledChange}
            warning={PIXI.utils.isWebGLSupported() ? null : CreatePageConstants.LIMITED_VISIBILITY_WARNING_TEXT}
            dense={false}
        >
            <List dense disablePadding>
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <LyricsGlowBlurListItem />
                        },
                        {
                            width: 6,
                            component: <LyricsGlowScaleListItem />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { glowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const glowSettingsEnabled = glowSettings ? glowSettings.enabled : false;
    return { glowSettingsEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsGlowListItem);
